import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TbLockPassword, TbDeviceMobileCheck } from "react-icons/tb";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";
import HttpClient from "../../Services/HttpClient";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { mobileNo } = useParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passIcon, setPassIcon] = useState(false);

  const passwordRef = useRef(null);
  const password2Ref = useRef(null);

  const EyeIconPass = passIcon ? MdOutlineRemoveRedEye : AiOutlineEyeInvisible;

  const [searchParams] = useSearchParams();

  const emaill = searchParams.get("email");
  const token = searchParams.get("token");

  console.log("Email:", email);
  console.log("Token:", token);

  const validatePassword = (pass) => {
    if (!pass) return "Enter password";
    if (!/[A-Z]/.test(pass)) return "Password must contain uppercase letters";
    if (!/[a-z]/.test(pass)) return "Password must contain lowercase letters";
    if (!/[0-9]/.test(pass)) return "Password must contain numbers";
    if (pass.length < 8) return "Password must be at least 8 characters";
    if (!/[!*@#%&()^~{}]/.test(pass))
      return "Password must contain a special character";
    return "";
  };

  const handleLogin = () => {
    let valid = true;

    // EMAIL VALIDATION
    // if (email.length === 0) {
    //   setPasswordError("Password is required");
    //   passwordRef.current.focus();
    //   valid = false;
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    //   setPasswordError("Please enter a valid email address");
    //   passwordRef.current.focus();
    //   valid = false;
    // } else {
    //   setPasswordError("");
    // }

      // PASSWORD EMPTY CHECK
  if (!password) {
    toast.error("Password is required");
    passwordRef.current.focus();
    return;
  }

  // PASSWORD VALIDATION
  const validationMessage = validatePassword(password);
  if (validationMessage) {
    toast.error(validationMessage);
    passwordRef.current.focus();
    return;
  }

  // CONFIRM PASSWORD EMPTY
  if (!confirmPassword) {
    toast.error("Confirm password is required");
    password2Ref.current.focus();
    return;
  }

  // PASSWORD MATCH CHECK
  if (password !== confirmPassword) {
    toast.error("Passwords do not match");
    password2Ref.current.focus();
    return;
  }




    if (!valid) return;

    let payload = new FormData();
    payload.append("new_password", password);
    payload.append("email", emaill);
    payload.append("token", token);
    post(URLS.RESET_PASSWORD, payload)
      .then((res) => {
        if (res?.status == "success") {
          localStorage.setItem("token", res?.token);
          localStorage.setItem("admin_details", JSON.stringify(res?.data));
          HttpClient.defaults.headers.common["Authorization"] =
            `Bearer ${res?.token}` || "";
          toast.success(res?.message);
          setTimeout(() => {
            navigate("/general-user");
            
          }, 500);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const keydownHandler = (event) => {
    if (event.key == "Enter") {
      handleLogin();
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/general-user");
    }
  }, []);

  return (
    <div className="container-fluid">
      <div className="row vh-100">
        <div
          className="col-lg-6 col-md-6 col-12 p-0"
          style={{ height: "100vh" }}
        >
          <div
            style={{
               backgroundImage: "url(https://khyathi-bucket-store.s3.us-east-1.amazonaws.com/loginLogo.png)",
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </div>

        <div style={{ height: '100vh' }} className="col-lg-6 col-md-6 col-12 d-flex flex-column justify-content-end align-items-center bg-white text-white">
          <div className="w-60">
            <h2 className="mb-3 f8 text-left fs-5 text-black">Reset Password</h2>

            {/* Email INPUT */}
            <div className="mb-3">
              <label className="form-label">Password</label>
              <div className="mb-3">
                <div className="position-relative mb-1">


                  {/* PASSWORD INPUT */}
                  <input
                    type='password'
                    className={`form-controlpass ${passwordError ? "border border-danger" : ""
                      }`}
                    placeholder="Enter your Password"
                    value={password}
                    ref={passwordRef}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError("");
                    }}
                    onKeyDown={keydownHandler}
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #666",
                      height: "46px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                  />
                </div>
                {passwordError && (
                  <small className="text-danger">{passwordError}</small>
                )}
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Confirm Password</label>
              <div className="mb-3">
                <div className="position-relative mb-1">


                  {/* PASSWORD INPUT */}
                  <input
                    type='password'
                    className={`form-controlpass ${passwordError ? "border border-danger" : ""
                      }`}
                    placeholder="Enter your Password"
                    value={confirmPassword}
                    ref={password2Ref}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setPasswordError("");
                    }}
                    onKeyDown={keydownHandler}
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #666",
                      height: "46px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                  />
                </div>
                {passwordError && (
                  <small className="text-danger">{passwordError}</small>
                )}
              </div>
            </div>

            <button
              style={{ backgroundColor: "#259AF9" }}
              className="btn  w-100 text-white border-rounded  d-block py-2 fw-bold"
              onClick={handleLogin}
            >
              Submit
            </button>
          </div>
          <div
            style={{
              // backgroundImage: `url(${require("../../common/Assets/imgs/bgLogin.png")})`,
               background:"url(https://khyathi-bucket-store.s3.us-east-1.amazonaws.com/bgLogin.png)" ,
              height: "38%",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }} className="w-100" ></div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
